import { createContext, useContext, useEffect, useState } from "react"
import { jwtDecode } from "jwt-decode"
import { useDispatch, useSelector } from 'react-redux'
import { handleLogout } from '@store/actions/auth'


const FacilityContext = createContext()

export const FacilityProvider = ({ children }) => {
  const [isHaveFacility, setIsHaveFacility] = useState(true)
  const [currentFacility, setCurrentFacility] = useState(null)

  const authStore = useSelector(state => state.auth)

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken')
    if (!accessToken) {      
      setIsHaveFacility(true)
      return
    }

    try {
      const decoded = jwtDecode(accessToken)      

      if (decoded?.facilities?.length > 0) {        
        setIsHaveFacility(true)        
        setCurrentFacility(JSON.parse(localStorage.getItem('currentFacility')))
      } else {        
        setIsHaveFacility(false)
      }
    } catch (error) {      
      setIsHaveFacility(false)
    }
  }, [authStore.userData]) // 👈 only run once (on mount)

  return (
    <FacilityContext.Provider value={{ isHaveFacility, currentFacility }}>
      {children}
    </FacilityContext.Provider>
  )
}

export const useFacility = () => useContext(FacilityContext)
